export const CSV_SKIP_IMPORT_HEADER = 'Skip import';

export const DELIVERY_CSV_HEADERS = [
  'Delivery Date',
  'Product description',
  'Product reference number',
  'Barn number',
  'Units delivered',
  CSV_SKIP_IMPORT_HEADER,
] as const;

export const DEPARTURE_CSV_HEADERS = [
  'Date',
  'Barn',
  'Type',
  'Amount',
  'Slaughterhouse',
  'Departure weight',
  'Rejection at slaughterhouse',
  'Rejection during transport',
  'Total slaughterweight',
  CSV_SKIP_IMPORT_HEADER,
] as const;
